import type { ModelDefinition } from "@/__main__/data-model.mjs";
import { item } from "@/game-fortnite/models/item.mjs";

export const ItemQuantity = {
  item,
  quantity: Number,
} satisfies ModelDefinition;
